import type { SshSessionEvidenceView as SshEvidenceView } from "@p0security/shared/integrations/sessions/types";
import { Collapse } from "antd";

import { AuditEventsRowsTable } from "./AuditEventsSessionView";
import { SessionViewHeader } from "./SessionViewHeader";
import { TerminalRecordingSessionsList } from "./TerminalRecordingSessionView";

const sectionHeaderStyle = {
  background: "#fafafa",
  fontWeight: 600,
  marginBottom: 8,
};

/** Renders combined SSH replay and audit evidence for a single request. */
export const SshSessionEvidenceView = ({
  view,
  loading,
  getSession,
}: {
  view: SshEvidenceView;
  loading?: boolean;
  getSession?: () => void;
}) => {
  return (
    <>
      <SessionViewHeader
        view={view}
        fallbackTitle="SSH Session Evidence"
        loading={loading}
        onRefresh={getSession}
      />
      <Collapse
        defaultActiveKey={["replay"]}
        destroyOnHidden
        ghost
        items={[
          {
            key: "replay",
            label: "Replay",
            styles: {
              header: sectionHeaderStyle,
            },
            children: (
              <TerminalRecordingSessionsList sessions={view.sessions} />
            ),
          },
          ...(view.rows.length > 0
            ? [
                {
                  key: "audit-trail",
                  label: "Audit Trail",
                  styles: {
                    header: sectionHeaderStyle,
                  },
                  children: <AuditEventsRowsTable rows={view.rows} />,
                },
              ]
            : []),
        ]}
      />
    </>
  );
};
